import { RedirectRoute } from '../Routing/types';
const redirects: RedirectRoute[] = [
  {
    path: '/meals',
    redirectTo: '/meals/cookbook',
  },
];

export default redirects;
